import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { RedlineTool } from '../pdf-redline.component';

@Component({
  selector: 'app-redline-toolbar',
  templateUrl: './redline-toolbar.component.html',
  styleUrls: ['./redline-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RedlineToolbarComponent {
  @Input() activeTool: RedlineTool = '';
  @Input() lineWidth = 1;
  @Input() lineWidthDisabled = false;
  @Input() canUndo = false;
  @Input() canRedo = false;
  @Input() isUndoRedoBusy = false;
  @Input() isDownloading = false;
  @Input() isSendingToMips = false;

  @Output() undo = new EventEmitter<void>();
  @Output() redo = new EventEmitter<void>();
  @Output() toolChange = new EventEmitter<RedlineTool>();
  @Output() lineWidthChange = new EventEmitter<number>();
  @Output() clearActive = new EventEmitter<void>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() zoomIn = new EventEmitter<void>();
  @Output() zoomOut = new EventEmitter<void>();
  @Output() rotate = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();
  @Output() sendToMips = new EventEmitter<void>();
}
